/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Limits_BodyInputs */

const en_svc_research_limits_body = /** @type {(inputs: Svc_Research_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A brief is only as useful as it is checkable. These limits are built in.`)
};

const lv_svc_research_limits_body = /** @type {(inputs: Svc_Research_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopsavilkums ir noderīgs tik, cik to var pārbaudīt. Šīs robežas ir iebūvētas.`)
};

/**
* | output |
* | --- |
* | "A brief is only as useful as it is checkable. These limits are built in." |
*
* @param {Svc_Research_Limits_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_limits_body = /** @type {((inputs?: Svc_Research_Limits_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Limits_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_limits_body(inputs)
	return en_svc_research_limits_body(inputs)
});